import type { DatadogGridReplayPrivacy } from '@thinkalpha/ui-table-svelte/datadogGridReplayPrivacy';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { enableDatadogGridReplayCapture } from 'src/lib/featureFlags/flags/enableDatadogGridReplayCapture';

export function resolveDatadogGridReplayPrivacy(captureEnabled: boolean): DatadogGridReplayPrivacy {
    return captureEnabled ? 'allow' : 'hidden';
}

/** Resolves the app-wide grid recording policy from its model-owned feature flag. */
export function useDatadogGridReplayPrivacy(): DatadogGridReplayPrivacy {
    return resolveDatadogGridReplayPrivacy(useFeatureFlag(enableDatadogGridReplayCapture));
}
